import { toast } from '@buffer-mono/popcorn'

import { mentionDetailsRoute } from '~publish/legacy/routes'

/**
 * The absolute, shareable URL for a mention. Always uses the all-channels
 * Community path so the link works for any recipient regardless of which
 * Community view they were in when it was copied.
 */
const getMentionShareLink = (mentionId: string): string =>
  `${window.location.origin}${mentionDetailsRoute.getRoute({ mentionId })}`

/**
 * Copies the shareable link for a mention to the clipboard and toasts the
 * outcome. Returns whether the copy succeeded.
 */
export const copyMentionLinkToClipboard = async (
  mentionId: string,
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(getMentionShareLink(mentionId))
    toast.success('Mention link copied')
    return true
  } catch {
    toast.error('Unable to copy link')
    return false
  }
}
